<nav class="navbar navbar-fiehnlab navbar-toggleable-sm navbar-expand-md navbar-dark" aria-label="Navigation bar">
  <div class="container-fluid">
    <a class="navbar-brand ms-3" routerLink="/">LC-BinBase Control Panel</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Acquisition
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/acquisition/lcms">Create LC-MS Acquisition Table</a></li>
            <li><a class="dropdown-item" routerLink="/acquisition/gcms">Create GC-MS Acquisition Table</a></li>
            <li><a class="dropdown-item" routerLink="/acquisition/targeted">Get StudyId for Targeted Assays</a></li>
            <li><a class="dropdown-item" routerLink="/acquisition/downloads">Download Acquisition Files</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Experiments
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/experiment/main">Experiment List</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Samples
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/experiment/sample">Sample Search</a></li>
            <li><a class="dropdown-item" routerLink="/experiment/compare-random">Investigate Random Samples</a><li>
            <li><a class="dropdown-item" routerLink="/scheduler/compare/samples">Compare Sample ISTDs</a><li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Jobs
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/scheduler/dataViewer">Job Search</a></li>
            <li><a class="dropdown-item" routerLink="/scheduler/container">Create a Job</a></li>
            <li><a class="dropdown-item" routerLink="/scheduler/group-job">Group Jobs</a></li>
            <li><a class="dropdown-item" routerLink="/scheduler/metadata">Job Metadata</a></li>
            <li><a class="dropdown-item" routerLink="/diags">Job Diagnostics</a></li>
            <li><a class="dropdown-item" routerLink="/diags/flash-eic">FlashEIC Diagnostics</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            BinView
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/binview/binview">BinView</a></li>
            <li><a class="dropdown-item" routerLink="/binview/compound">Compound Search</a></li>
            <li><a class="dropdown-item" routerLink="/binview/duplicates">Compound Duplicates</a></li>
            <li><a class="dropdown-item" routerLink="/binview/id">Upload Identifiers</a></li>
            <li><a class="dropdown-item" routerLink="/binview/hidden">Recent Hidden Bins</a></li>
          </ul>
        </li>

        @if (false) {
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Standards Mgmt
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/standards">Available Methods</a></li>
            </ul>
          </li>
        }

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Monitor
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/utility/queuestat">Queues Status</a></li>
            <li><a class="dropdown-item" routerLink="/monitor">Quality Control</a></li>
            <li><a class="dropdown-item" routerLink="/audit">Bin and Sample Change Logs</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Utilities
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/utility/eic">EIC Viewer</a></li>
            <li><a class="dropdown-item" routerLink="/utility/spectrum">Spectra Viewer</a></li>
            <li><a class="dropdown-item" routerLink="/utility/transpose">Edit Formatting</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Documentation
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/utility/documentation">Documentation for BinView Tools</a></li>
            <li><a class="dropdown-item" href="https://chatgpt.com/g/g-6a04ce1db5c081919430499c5a5fc8f5-binbasegpt" target="_blank" rel="noopener noreferrer">BinBaseGPT</a></li>
          </ul>
        </li>

      </ul>

      <ul class="navbar-nav ms-auto">

        <li class="nav-item dropdown" placement="bottom-right" display="dynamic">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <mat-icon style="position: relative; top: 5px;">account_circle</mat-icon> {{ userName() }} [{{ labName() }}]
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" (click)="logOut()">SignOut</a></li>
          </ul>
        </li>

      </ul>
    </div>
  </div>
</nav>
